module.exports = __webpack_public_path__ + "static/img/police.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/footer/police.png
// module id = teC1
// module chunks = 0